var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"de145773fbacb37dd6bb671df01ceb0d6c1026f4"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";
import { BrowserTracing } from "@sentry/nextjs";
import { excludeGraphQLFetch } from "apollo-link-sentry";
import posthog from "posthog-js";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_ORG = "aragro";
const SENTRY_PROJECT_ID = 1916813;
const TRACES_SAMPLE_RATE = Number(process.env.SENTRY_TRACES_SAMPLE_RATE || 0);

Sentry.init({
  enabled: !!process.env.ARAGRO_ENV,
  environment: process.env.ARAGRO_ENV,
  dsn:
    SENTRY_DSN ||
    "https://ad0a1b3a7b1942f0a2a475618e3076e3@o82583.ingest.sentry.io/1916813",
  integrations: [
    // Propagate sampled sentry-trace headers to Rails.
    new BrowserTracing(),
    // Two-way link: PostHog tags on Sentry events + $exception events in PostHog.
    new posthog.SentryIntegration(posthog, SENTRY_ORG, SENTRY_PROJECT_ID),
  ],
  tracesSampleRate: TRACES_SAMPLE_RATE,
  // Without browser tracing a shared trace id makes Rails sample whole
  // sessions, so let it sample each request on its own.
  tracePropagationTargets:
    TRACES_SAMPLE_RATE > 0 ? [/^\//, /^https?:\/\/[^/]*aragro\./] : [],
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
    "Non-Error promise rejection captured with value",
    "Switching tenant...",
    /Failed to read a named property 'removeEventListener' from 'Window'/,
    /posthog/i,
  ],
  // HubSpot autotrack noise (portal 20692225), caught by Sentry, app unaffected.
  denyUrls: [/20692225\.js/, /hs-scripts\.com/, /hs-analytics/, /hs-banner/],
  // By default, Sentry attaches all fetch events as breadcrumbs. Since `apollo-link-sentry` package tracks GraphQL requests as breadcrumbs,
  // they would show up duplicated in Sentry.
  beforeBreadcrumb: excludeGraphQLFetch,
  // Release version
  release: process.env.SENTRY_RELEASE,
  // add stack local variables to stack traces
  includeLocalVariables: true,
});
